<template>
  <div class="qrcode-content" :style="{ width: size * scale + 'px' }">
    <vue-qr :text="text" :margin="margin" :colorDark="color" colorLight="#fff" :logoSrc="logoSrc" :logoCornerRadius="4"
      :logoScale="logoScale" :size="size"></vue-qr>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
  components: {
    VueQr,
  },
  props: {
    text: {
      type: String,
    },
    size: {
      type: Number,
      default: 400,
    },
    logoScale: {
      type: Number,
      default: 0.2,
    },
    logo: "",
    margin: {
      type: Number,
      default: 0,
    },
    scale: {
      type: Number,
      default: 0.5,
    },
    color: {
      type: String,
      default: "#000",
    },
    type: "",
  },
  data() {
    return {
      logoSrc: "",
      loading: false,
    }
  },
  watch: {
    logo(val) {
      this.getLogoImg();
    },
    text() {
      console.log(this.text);
    },
  },
  mounted() {
    console.log(this.text);
    this.getLogoImg();
  },
  methods: {
    getLogoImg() {
      if (!this.logo) {
        return;
      }
      this.logoSrc = this.logo;
      // this.loading = true;
      // this.httpDownload("get", this.logo).then(res => {
      //   this.loading = false;
      //   this.logoSrc = this.logo;
      //   if (this.type == "blob") {
      //     this.func.blobToDataURI(res, data => {
      //       this.logoSrc = data;
      //     })
      //   }
      // }).catch(res => {
      //   this.loading = false;
      // })
    }
  }
}
</script>
<style lang="scss">
.qrcode-content {
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  position: relative;
  // box-shadow: 0 0 5px 0px #ddd;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/QrCode.vue